import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

const DefaultLink = ({ to, children }) => <a href={to}>{children}</a>;

DefaultLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

const FullHeightLink = ({ Link, to, label }) => (
  <Link to={to}>
    <div className="Navbar__FullHeightLink">{label}</div>
  </Link>
);

FullHeightLink.propTypes = {
  Link: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  // eslint-disable-next-line react/forbid-prop-types
  to: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
};

FullHeightLink.defaultProps = {
  // eslint-disable-next-line react/prop-types
  Link: DefaultLink,
};

export default FullHeightLink;
